/**
 * This file is used for setting up and connecting to Prismic.
 */

module.exports = {
  prismicRepo: "gsevee",
}
